import { useCallback, useEffect, useRef, useState } from 'react'

const DONE_MS = 2000

/* Tapping the selected chip/tab or Početna (spec 6): scrolled down → glide to
   the top; already at the top → refresh, with "Osvježavam vijesti…" under the
   chips and "Sve je ažurirano…" when nothing new came. */
export default function useTapToRefresh(feed) {
  const [row, setRow] = useState(null) // null | 'loading' | 'done'
  const timer = useRef(null)
  const refresh = feed.refresh

  const run = useCallback(async () => {
    clearTimeout(timer.current)
    setRow('loading')
    const { newCount, error } = await refresh({ markNew: true })
    if (!error && newCount === 0) {
      setRow('done')
      timer.current = setTimeout(() => setRow(null), DONE_MS)
    } else {
      setRow(null)
    }
  }, [refresh])

  const tap = useCallback(() => {
    if (window.scrollY > 4) window.scrollTo({ top: 0, behavior: 'smooth' })
    else run()
  }, [run])

  useEffect(() => () => clearTimeout(timer.current), [])
  return { row, tap, run }
}
